import { render, staticRenderFns } from "./HeaderUserNotifications.vue?vue&type=template&id=06623e27&scoped=true&lang=pug&"
import script from "./HeaderUserNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderUserNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserNotifications.vue?vue&type=style&index=0&id=06623e27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06623e27",
  null
  
)

export default component.exports